module.exports = __webpack_public_path__ + "img/aboutus_2.fa7b86bb.png";